import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import actions from '@/action/panZoom.js';

import styles from './Grid.css';
// import withStyles from 'isomorphic-style-loader/lib/withStyles'


const PHI = 1.618;
const PHI_A = PHI - 1;
const PHI_B = 1 - PHI_A;

function lcm(x, y) {
   return (!x || !y) ? 0 : Math.abs((x * y) / gcd(x, y));
}
function gcd(x, y) {
    while(y) {
        var t = y;
        y = x % y;
        x = t;
    }
    return x;
}

/** 
 * <p>Background component supports panning and zooming.</p>
 * <p>Each section of the configuration is an array. The active index is based on the current zoom and configured in the "mix" parameter.</p>
 */
class Grid extends Component {
    constructor(props) {
        super(props);

        this.config = props.config;

        this.canvasRef = React.createRef();

        // this.offScreenCanvas = document.createElement('canvas');
        // this.offScreenCanvas.width = 50;//maxBufferDim;
        // this.offScreenCanvas.height = 50;//maxBufferDim;

        let self = this;

        this.draw_throttled = function () {
            requestAnimationFrame(() => self.draw());
        }

        this.draw_throttled();
    }

    componentDidUpdate() {
        // console.log('did update', this.props);
        this.draw();
        // this.draw_throttled();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.panX != this.props.panX
            ||
            nextProps.panY != this.props.panY
            ||
            nextProps.z != this.props.z
            ||
            nextProps.width != this.props.width
            ||
           nextProps.height != this.props.height
            
            ) {
                return true
            } 

        return false
    }

    draw() {
        if (!this.canvasRef.current) {
            return;
        }

        const props = this.props;
        const config = props.config;

        const ctx = this.canvasRef.current.getContext("2d");
        const bufferCtx = ctx;//this.offScreenCanvas.getContext("2d");


        const z = this.props.z;
        const panX = this.props.panX;
        const panY = this.props.panY;
        const w = this.props.width;
        const h = this.props.height;

        // Background
        ctx.clearRect(0, 0, w, h);
        bufferCtx.clearRect(0, 0, w, h);

        if (props.config.background && props.config.background !== 'transparent') {
            bufferCtx.beginPath();
            bufferCtx.rect(0, 0, w, h);
            // console.log(props.config.background)
            bufferCtx.fillStyle = props.config.background;
            bufferCtx.fill();
        }

        const mixLen = config.mix ? config.mix.length : 1;
        for (var mix = 0; mix < mixLen; mix++) {

            //reset
            bufferCtx.globalAlpha = 1;

            if (config.mix) {
                let minZoom = config.mix[mix].minZoom;
                let maxZoom = config.mix[mix].maxZoom
                if (minZoom > z || maxZoom < z) {

                    let fadeZoom = config.mix[mix].fadeZoom;
                    if (fadeZoom && fadeZoom > Math.abs(1 - z / minZoom)) {
                        // console.log('z vs min', z, Math.abs(z - z/minZoom));
                        bufferCtx.globalAlpha = 1 - Math.abs(1 - z / minZoom) / fadeZoom;
                        // console.log(z/minZoom, Math.abs(1 - z/minZoom) / fadeZoom, ctx.globalAlpha);
                    } else if (fadeZoom && (fadeZoom > Math.abs(1 - z / maxZoom))) {
                        // console.log('z vs max', z, Math.abs(z - z/maxZoom));
                        bufferCtx.globalAlpha = 1 - Math.abs(1 - z / maxZoom) / fadeZoom;
                        // console.log(ctx.globalAlpha);
                    } else {
                        continue;
                    }
                }
            }

            let gridConfig = config.grid[mix] //|| config.grid[0];
            let scaleConfig = config.scale[mix] || config.scale[0];

            let wOffsetGrid = ((z * panX + w / 2) % (z * gridConfig.interval));
            let hOffsetGrid = ((z * panY + h / 2) % (z * gridConfig.interval));

            let wOffsetMinorGrid = ((z * panX + w / 2) % (z * gridConfig.minorInterval));
            let hOffsetMinorGrid = ((z * panY + h / 2) % (z * gridConfig.minorInterval));
            let spacingMinor = z * gridConfig.minorInterval;
            let minorLength = gridConfig.minorLength;// || gridConfig.length;

            let wOffsetScale = ((z * panX + w / 2) % (z * scaleConfig.tickInterval));
            let hOffsetScale = ((z * panY + h / 2) % (z * scaleConfig.tickInterval));
            let spacing = z * gridConfig.interval;
            let spacingScale = z * scaleConfig.tickInterval;

            // console.log('gridConfig', 
            //     spacingMinor||0 + minorLength||0,
            //     spacing||0 + spacingScale||0
            // );//, mix, config.mix.length, gridConfig, 
            // console.log(config);
            // let maxBufferDim = Math.floor(Math.max(1, Math.min(w, lcm(
            //     spacingMinor||0 + minorLength||0,
            //     spacing||0 + spacingScale||0
            // ))));
            // console.log(maxBufferDim)

            const w2 = w;//maxBufferDim;
            const h2 = h;//maxBufferDim;
            // this.offScreenCanvas.width = maxBufferDim;
            // this.offScreenCanvas.height = maxBufferDim;

            // Draw Optional MinorGrid
            bufferCtx.beginPath();
            bufferCtx.strokeStyle = gridConfig.minorColor;

            if (minorLength) {
                bufferCtx.lineWidth = z * minorLength;
                bufferCtx.setLineDash([gridConfig.minorWidth / 2, (z * gridConfig.minorInterval - gridConfig.minorWidth), gridConfig.minorWidth / 2, 0]);
            } else {
                bufferCtx.lineWidth = gridConfig.minorWidth;
                bufferCtx.setLineDash([]);
            }


            // Draw Horizontal
            for (let i = 0, len = h2 / spacingMinor; i < len; i++) {
                let y = i * spacingMinor + hOffsetMinorGrid;
                bufferCtx.moveTo(-spacingMinor + (wOffsetMinorGrid % spacingMinor), y);
                bufferCtx.lineTo(w2, y);
            }

            // Draw Vertical
            for (let i = 0, len = w2 / spacingMinor; i < len; i++) {
                let x = i * spacingMinor + wOffsetMinorGrid;
                bufferCtx.moveTo(x, -spacingMinor + (hOffsetMinorGrid % spacingMinor));
                bufferCtx.lineTo(x, h2);
            }

            // Finalize Grid
            bufferCtx.stroke();
            bufferCtx.closePath();


            // Draw Grid
            bufferCtx.beginPath();
            bufferCtx.strokeStyle = gridConfig.color;
            // console.log('c', gridConfig)

            if (gridConfig.length) {
                bufferCtx.lineWidth = (gridConfig.scaleLength === true) ? z* gridConfig.length : gridConfig.length;
                bufferCtx.setLineDash([gridConfig.width / 2, (z * gridConfig.interval - gridConfig.width), gridConfig.width / 2, 0]);
            } else {
                bufferCtx.lineWidth = gridConfig.width;
                bufferCtx.setLineDash([]);
            }


            // Draw Horizontal
            for (let i = 0, len = h2 / spacing + 1; i < len; i++) {
                let y = i * spacing + hOffsetGrid;
                bufferCtx.moveTo(-spacing + (wOffsetGrid % spacing), y);
                bufferCtx.lineTo(w2, y);
            }

            // Draw Vertical
            for (let i = 0, len = w2 / spacing + 1; i < len; i++) {
                let x = i * spacing + wOffsetGrid;
                bufferCtx.moveTo(x, -spacing + (hOffsetGrid % spacing));
                bufferCtx.lineTo(x, h2);
            }

            // Finalize Grid
            bufferCtx.stroke();
            bufferCtx.closePath();


            //copy
            // var ptrn = ctx.createPattern(this.offScreenCanvas, 'repeat'); // Create a pattern with this image, and set it to "repeat".
            // ctx.fillStyle = ptrn;
            // ctx.fillRect(0, 0, w, h); 


            // Draw Axis
            ctx.setLineDash([]);
            ctx.beginPath();

            ctx.strokeStyle = config.axis.color;
            ctx.lineWidth = config.axis.width;

            // Draw Horizontal
            ctx.moveTo(0, h / 2 + z * panY);
            ctx.lineTo(w, h / 2 + z * panY);

            // Draw Vertical
            ctx.moveTo(w / 2 + z * panX, 0);
            ctx.lineTo(w / 2 + z * panX, h);

            // Finalize Axis
            ctx.stroke();
            ctx.closePath();

            // Draw Ticks
            // ctx.setLineDash([z * scaleConfig.tickWidth / 2, (z * scaleConfig.tickInterval - z * scaleConfig.tickWidth), z * scaleConfig.tickWidth / 2, 0]);
            ctx.setLineDash([scaleConfig.tickWidth / 2, (z * scaleConfig.tickInterval - scaleConfig.tickWidth), scaleConfig.tickWidth / 2, 0]);
            ctx.beginPath();

            ctx.strokeStyle = scaleConfig.tickColor;
            ctx.lineWidth = scaleConfig.tickLength;

            // Horizontal
            ctx.moveTo(-spacingScale + wOffsetScale, z * panY + h / 2);
            ctx.lineTo(w, z * panY + h / 2);
            // Vertical
            ctx.moveTo(z * panX + w / 2, -spacingScale + hOffsetScale);
            ctx.lineTo(z * panX + w / 2, h);


            // Finalize Ticks
            ctx.stroke();
            ctx.closePath();
            ctx.setLineDash([]);


            // Draw Axis Labels
            if (scaleConfig.labels) {
                ctx.textBaseline = 'middle';
                ctx.textAlign = 'center';
                ctx.fillStyle = scaleConfig.labels.color;
                ctx.font = scaleConfig.labels.fontSize + ' ' + scaleConfig.labels.font;

                let fontSize = parseInt(scaleConfig.labels.fontSize, 10);
                let textPadding = fontSize * PHI_A / 2;
                // Draw Horizontal
                for (let i = 0, len = w / spacingScale; i < len; i++) {
                    let x = i * spacingScale + wOffsetScale;
                    let wart = ((w / 2 + z * panX) / spacingScale);
                    let labelIndex = i - ((wart > 0) ? Math.floor(wart) : Math.ceil(wart));
                    let label = labelIndex * scaleConfig.tickInterval;

                    if ((labelIndex) % scaleConfig.labels.step === 0) {
                        /// get width of text
                        let width = ctx.measureText(label).width + textPadding * 2;
                        let height = fontSize + textPadding * 2;

                        // let y = Math.min(h - z * scaleConfig.tickLength * 0.31, Math.max(height + z * scaleConfig.tickLength * 0.31, z * panY + h / 2 - z * scaleConfig.tickLength * 0.56 + -config.axis.width/2));
                        let y = Math.min(h, Math.max(height, z * panY + h / 2 - scaleConfig.tickLength * PHI_A + textPadding + -config.axis.width / 2));

                        /// draw background rect assuming height of font
                        if ((config.background && !scaleConfig.labels.no_bg) || label == 0) {
                            ctx.fillStyle = config.background;
                            ctx.fillRect(+ x - width / 2, y - height, width, height);
                        }

                        ctx.fillStyle = scaleConfig.labels.color;

                        ctx.fillText(label, + x, y - (fontSize / 2 + textPadding));
                    }
                }
                

                // Draw Vertical
                ctx.textAlign = 'left';
                for (let i = 0, len = h / spacingScale; i < len; i++) {
                    let y = i * spacingScale + hOffsetScale;
                    let wart = ((h / 2 + z * panY) / spacingScale);
                    let labelIndex = i - ((wart > 0) ? Math.floor(wart) : Math.ceil(wart));
                    let label = labelIndex * scaleConfig.tickInterval;


                    if (labelIndex % scaleConfig.labels.step === 0) {
                        /// get width of text
                        let width = ctx.measureText(label).width + textPadding * 2;
                        let height = fontSize + textPadding * 2;
                        // let x = Math.min(w - width - z * scaleConfig.tickLength * .31, Math.max(z * scaleConfig.tickLength * 0.31, z * panX + w / 2 + z * scaleConfig.tickLength * 0.56 + config.axis.width/2));
                        let x = Math.min(w - width, Math.max(0, z * panX + w / 2 + scaleConfig.tickLength * PHI_A - textPadding + config.axis.width / 2));

                        if ((config.background && !scaleConfig.labels.no_bg) || label == '0') {
                            /// draw background rect assuming height of font
                            ctx.fillStyle = config.background;
                            ctx.fillRect(x, y - (fontSize / 2) - textPadding, width, height);
                        }

                        ctx.fillStyle = scaleConfig.labels.color;
                        ctx.fillText(label, x + textPadding, y);
                    }
                }
            }

            //reset
            // ctx.globalAlpha = 1;
            bufferCtx.globalAlpha = 1;
        }
    }

    render() {
        return <canvas
            ref={this.canvasRef}
            className="grid"
            width={this.props.width}
            height={this.props.height}
        />;
    }
}



const mapStateToProps = (state, ownProps) => {
    let background;
    let axis_color;
    let tick_color;
    let grid_color;
    let label_color;

    // console.log('mapStateToProps', JSON.stringify(state), ownProps);

    switch (state.theme) {
        case 'sb-show-main theme-dark':
            background = '#000000';
            axis_color = '#FFFFFF';
            label_color = '#FFFFFF';
            tick_color = '#FFFFFF';
            grid_color = '#FFFFFF';
            break;
        case 'sb-show-main theme-light':
            background = '#FFFFFF';
            axis_color = '#000000';
            label_color = '#000000';
            tick_color = '#000000';
            grid_color = '#000000';
            break;
        case 'sb-show-main theme-cool':
            background = '#333540';
            axis_color = '#535560';
            label_color = '#535560';
            tick_color = '#535560';
            grid_color = '#535560';
            break;
        case 'sb-show-main theme-warm':
            background = '#403335';
            axis_color = '#605355';
            label_color = '#605355';
            tick_color = '#605355';
            grid_color = '#605355';
            break;
        default:
            background = ownProps.config.background;
            axis_color = ownProps.config.axis.color;
            label_color = ownProps.config.scale[0].labels ? ownProps.config.scale[0].labels.color : null;
            tick_color = ownProps.config.scale[0].tickColor;
            grid_color = ownProps.config.grid[0].color;
    }

    let axis = Object.assign({}, ownProps.config.axis, {
        color: axis_color
    });

    let scale = [].concat(ownProps.config.scale);
    for (let i = 0, len = scale.length; i < len; i++) {
        let labels = Object.assign({}, ownProps.config.scale[i].labels, {
            color: label_color
        });

        let scaleN = Object.assign({}, ownProps.config.scale[i], {
            tickColor: tick_color,
            labels: labels
        });

        scale[i] = scaleN;
    }

    let grid = [].concat(ownProps.config.grid);
    for (let i = 0, len = grid.length; i < len; i++) {

        let gridN = Object.assign({}, ownProps.config.grid[i]
        //     , {
        //     color: grid_color,
        // }
        );

        grid[i] = gridN;
    }

    let config = Object.assign({}, ownProps.config, {
        background,
        axis,
        scale,
        grid
    });

    return Object.assign(
        {},
        { 
            z: state.camera.zoom * ownProps.scale, 
            width: ownProps.width || state.camera.size.width,
            height: ownProps.height ||  state.camera.size.height,
            
            // width: , 
            // height: 
            panX: state.camera.pan.x * ownProps.scale,
            panY: state.camera.pan.y * ownProps.scale
        }, 
        ownProps,
        { config }
    );
}

Grid.displayName = "GridComponent";

const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(Grid);
connectedComponent.displayName = "Grid";


Grid.propTypes = {
    /**
     * Full Configuration object
     */
    config: PropTypes.shape({
        background: PropTypes.string,
        axis: PropTypes.shape({
            color: PropTypes.string,
            width: PropTypes.number
        }).isRequired,
        scale: PropTypes.arrayOf(PropTypes.shape({
            tickInterval: PropTypes.number.isRequired,
            tickColor: PropTypes.string.isRequired,
            tickLength: PropTypes.number.isRequired,
            labels: PropTypes.shape({
                step: PropTypes.number,
                color: PropTypes.string,
                font: PropTypes.string,
                fontSize: PropTypes.string
            })
        })).isRequired,
        grid: PropTypes.arrayOf(PropTypes.shape({
            color: PropTypes.string.isRequired,
            interval: PropTypes.number.isRequired,
            width: PropTypes.number,
            length: PropTypes.number,
        })).isRequired,
        mix: PropTypes.arrayOf(PropTypes.shape({
            minZoom: PropTypes.number.isRequired,
            maxZoom: PropTypes.number.isRequired,
            fadeZoom: PropTypes.number.isRequired,
        })),
    }).isRequired
};

export default connectedComponent;
export { Grid as GridComponent };